import React, { Component, Fragment } from "react";
import { Provider } from "react-redux";
import Helmet from "react-helmet";
import ReactGA from "react-ga";
import { ConnectedRouter } from "connected-react-router";
import createHistory from "history/createBrowserHistory";
import Amplify from "aws-amplify";
import * as Sentry from "@sentry/browser";
import {
  withAuthenticator,
} from "aws-amplify-react";
import configureStore from "./redux/configureStore";
import authProvider from "./lib/authProvider";
import authListener from "./lib/authListener";
import Analytics from 'components/analytics';
import ScrollTop from 'components/scrolltop';
import Main from "./Main";
import config from "./config";

const history = createHistory();
const store = configureStore(history);

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: config.API
});

authProvider(store);
authListener(store);

Sentry.init({
  dsn: "https://8b52e191eac04262b38b082105964367@sentry.io/1404812",
  captureUnhandledRejections: false
});

ReactGA.initialize(
  [
    {
      trackingId: "UA-1880575-21",
      gaOptions: {
        name: "tracker1"
      }
    },
    {
      trackingId: "UA-1880575-19",
      gaOptions: { name: "tracker2" }
    }
  ],
  { debug: false, alwaysSendToDefaultTracker: false }
);

const WithAuthMain = withAuthenticator(Main, false, [], null, null, {
  hiddenDefaults: ["phone_number"]
});

class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Fragment>
            <ScrollTop />
            <Analytics>
              <WithAuthMain />
            </Analytics>
            <Helmet titleTemplate="Qprints - %s" />
          </Fragment>
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default App;
